var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pinch-wrapper",style:(_vm.zoomStyles),on:{"touchstart":_vm.start,"touchmove":_vm.move,"touchend":_vm.end}},[_c('img',{ref:"image ",staticClass:"pinch-img",class:{rotateImage: _vm.rotate},attrs:{"src":_vm.src,"alt":_vm.alt,"id":"pinch-img","usemap":"#image-map"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9482c172","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PinchImage.vue
// module id = null
// module chunks = 